import React, { useState, useEffect } from "react";
import * as yup from "yup";
import Swal from "sweetalert2";
import {
  getOutletCashAccount,
  saveOutletCashAccount,
} from "../../../../../services/sales/outletService";

import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
import AppForm from "../../../../../partials/content/Forms/AppForm";
import OutletCashAccountFormContent from "./OutletCashAccountFormContent";
const cashAccountSchema = yup.object().shape({
  outletCashAccount: yup.array().of(
    yup.object().shape({
      accountName: yup.string().required("Account is Required"),
    })
  ),
});
function OutletCashAccountForm({ outletID: outletIDprop = 0, match }) {
  let outletID = 0;
  if (outletIDprop > 0) {
    outletID = outletIDprop;
  } else {
    const { outletID: outletIDparam = 0 } = match.params;
    outletID = parseInt(outletIDparam);
  }
  const { reload } = useGlobalData();

  const [data, setData] = useState({
    outletCashAccount: [],
  });

  async function getOutletCashAccountData(outletID) {
    const response = await getOutletCashAccount(outletID);
    const { data } = response.data;
    setData({ outletCashAccount: data.outletCashAccount });
  }
  useEffect(() => {
    getOutletCashAccountData(outletID);
  }, [outletID, reload]);

  return (
    <AppForm
      initialValues={data}
      validationSchema={cashAccountSchema}
      onSubmit={(values, { resetForm, setStatus, setSubmitting }) => {
        Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
          },
          buttonsStyling: false,
        })
          .fire({
            title: "Are you sure want to save this Outlet Cash Account ?",
            text: "Please note that you are responsible for this action",
            icon: "question",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
            cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              saveOutletCashAccount(values.outletCashAccount).then(
                (response) => {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  }).fire({
                    title: "Saved",
                    html: response.data.message,
                    icon: "success",
                    showCloseButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                  });
                  getOutletCashAccountData(outletID);
                }
              );
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Cancelled",
                text: "No change has been made",
                icon: "info",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            }
          });
      }}
    >
      <OutletCashAccountFormContent outletID={outletID} />
    </AppForm>
  );
}

export default OutletCashAccountForm;
